import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { getUsersAdmin } from '../utils/api';
import Chip from '@mui/material/Chip';
import Button from '@mui/material/Button';
import Done from '@mui/icons-material/Done';
import Star from '@mui/icons-material/Star';
import StarBorder from '@mui/icons-material/StarBorder';
import List from '@mui/icons-material/List';
import NavigateNext from '@mui/icons-material/NavigateNext';
import NavigateBefore from '@mui/icons-material/NavigateBefore';
import Close from '@mui/icons-material/Close';
import Edit from '@mui/icons-material/Edit';
import Print from '@mui/icons-material/Print';
import Image from './image';

const ProblemViewer = (props) => {
  const [isAdmin, setIsAdmin] = useState(false);
  useEffect(() => {
    if (props.accessToken) {
      getUsersAdmin(props.accessToken).then((res) => { setIsAdmin(res) });
    }
  }, [props.accessToken]);

  return (
    <div style={{
        position: 'fixed',
        zIndex: 9999,
        width: '100vw',
        height: '100vh',
        textAlign: 'center',
        top: '0',
        left: '0',
        background: 'rgba(0,0,0,0.8)',
        }}>
        <Chip style={{position: 'absolute', zIndex: 999, opacity: 0.5, textAlign: 'center', top: '10px', left: '20px'}} label={"#" + props.p.nr + " " + props.p.type + " " + props.p.grade} />
        <div style={{position: 'absolute', zIndex: 999, opacity: 0.5, textAlign: 'center', top: '10px', right: '20px'}}>
          {isAdmin && <Button style={{zIndex: 999}} size="small" variant="contained" color="secondary" component={Link} {...{ to: `/problem-edit/${props.p.id}` } as any}><Edit /></Button>}
          {isAdmin && <Button style={{zIndex: 999}} size="small" variant="contained" color="secondary" component={Link} {...{ to: `/print/${props.p.id}` } as any} target="_blank"><Print /></Button>}
          {props.p.ticks && props.p.ticks.length>0 && <Button style={{zIndex: 999}} size="small" variant="contained" color="secondary" onClick={props.openTickListModal}><List /></Button>}
          <Button style={{zIndex: 999}} size="small" variant="contained" color="secondary" onClick={props.openTickModal}><Done /></Button>
          {props.isAuthenticated && <Button style={{zIndex: 999}} size="small" variant="contained" color="secondary" onClick={props.toggleStar}>{props.p.star? <Star /> : <StarBorder />}</Button>}
          <Button style={{zIndex: 999}} size="small" variant="contained" color="secondary" onClick={props.closeShowProblem}><Close /></Button>
        </div>

        <Image shapesIn={props.p.shapes} mediaId={props.p.mediaId} width={props.p.width} height={props.p.height} maxHeight="100vh" onClick={null} alignLeft={false}/>
        {props.navigate && 
          <>
            <Button variant="text" color="secondary" onClick={() => props.navigate(-1)} style={{opacity: 0.5, position: 'absolute', zIndex: 998, left: '20px', top: '0', bottom: '0', margin: 'auto'}}><NavigateBefore /></Button>
            <Button variant="text" color="secondary" onClick={() => props.navigate(1)} style={{opacity: 0.5, position: 'absolute', zIndex: 998, right: '20px', top: '0', bottom: '0', margin: 'auto'}}><NavigateNext /></Button>
          </>
        }
      </div>
  );
}

export default ProblemViewer;